import React from 'react';
import { I18nProvider } from '@react-aria/i18n';

import { Provider } from 'mobx-react';
import { observer } from 'mobx-react-lite';

import TerminalDialogWrapper from 'bz-core-controls/controls/payments/shared/terminal-payment-dialog/terminal-dialog-wrapper';

import AuthStore from 'bz-stores/lib/auth-store';

import { DictionaryStoreProvider } from 'bz-utilities/dictionary/dictionary-provider';
import history from 'bz-utilities/modules/networking/history/rr4';
import Register from 'bz-utilities/modules/plugins/register';

import { CacheProvider } from 'tm3-core/cache';

import PermissionsProvider from 'controls/permissions';

import { AnalyticsProvider } from 'core/analytics';

import License from '../../../../../app/controls/license';
import PaywallProvider from './components/account/paywall/provider';
import PaywallDialog from './components/account/paywall/dialog';

export interface IProps extends React.PropsWithChildren {}

const ClickAppProviders = observer<IProps>((props) => {
  return (
    <Provider authStore={AuthStore} historyStore={history}>
      <AnalyticsProvider>
        <I18nProvider locale="en-GB">
          <PaywallProvider>
            <Register>
              <CacheProvider>
                <DictionaryStoreProvider>
                  <PermissionsProvider>
                    <TerminalDialogWrapper>
                      <License>{props.children}</License>
                    </TerminalDialogWrapper>
                  </PermissionsProvider>
                </DictionaryStoreProvider>
              </CacheProvider>
            </Register>
            <PaywallDialog />
          </PaywallProvider>
        </I18nProvider>
      </AnalyticsProvider>
    </Provider>
  );
});

ClickAppProviders.displayName = 'ClickAppProviders';

export default ClickAppProviders;
